import { Input, Text } from "components/base/Form";
import { CubeSizeInput } from "components/shared/ItemSizeInput";
import { useContext } from "react";
import { parseFloatValue } from "utils/number";
import { ProductContext } from "./ProductForm";

const PackingShipmentView = () => {
  const { product, setProduct } = useContext(ProductContext);

  const barcodes = {
    innerBoxBarcodeEan: "Inner Box Barcode(EAN)",
    innerBoxBarcodeUpc: "Inner Box Barcode(UPC)",
    outerCartonBarcodeEan: "Outer Carton Barcode(EAN/GTIN14)",
    outerCartonBarcodeUpc: "Outer Carton Barcode(UPC/GTIN14)",
    innerCartonBarcodeEan: "Inner Carton Barcode(EAN/GTIN14)",
    innerCartonBarcodeUpc: "Inner Carton Barcode(UPC/GTIN14)",
    innerBoxBarcodeJd: "Inner Box Barcode(JD)",
    outerCartonBarcodeJd: "Outer Carton Barcode(JD)",
  };

  const outerCartonCbm = (x, y, z) => {
    const safeX = Number.parseFloat(x);
    const safeY = Number.parseFloat(y);
    const safeZ = Number.parseFloat(z);

    if (
      !Number.isFinite(safeX) ||
      !Number.isFinite(safeY) ||
      !Number.isFinite(safeZ)
    ) {
      return 0;
    }

    return ((safeX + 0.5) * (safeY + 0.5) * (safeZ + 0.5)) / (100 * 100 * 100);
  };

  return (
    <div className="card">
      <h5>Packing and Shipment</h5>
      <div className="mt-2 -mx-2">
        <table>
          <tbody>
            <tr>
              <td>
                <label>Packing: </label>
              </td>
              <td className="w-full">
                <Input
                  className="w-full"
                  value={product.packing}
                  onChange={(e) =>
                    setProduct((prev) => ({ ...prev, packing: e.target.value }))
                  }
                  placeholder="Packing describe how the product is packed, for example: 2-tier, 1-tier, Bulk, etc."
                />
              </td>
            </tr>
            <tr>
              <td className="align-baseline">
                <label>Packing Name: </label>
              </td>
              <td className="w-full align-baseline">
                <Input
                  className="w-full"
                  value={product.packingName}
                  onChange={(e) =>
                    setProduct((prev) => ({
                      ...prev,
                      packingName: e.target.value,
                    }))
                  }
                  placeholder=""
                />
                <div className="opacity-70 mt-1 mx-1">
                  Packing Name is used in shipments right now.
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <label>Shipping Mark Name: </label>
              </td>
              <td className="w-full">
                <Input
                  className="w-full"
                  value={product.shippingMarkName}
                  onChange={(e) =>
                    setProduct((prev) => ({
                      ...prev,
                      shippingMarkName: e.target.value,
                    }))
                  }
                  placeholder=""
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>CCC Info: </label>
              </td>
              <td className="w-full">
                <Text
                  value={product.cccInfo}
                  onChange={(e) =>
                    setProduct((prev) => ({ ...prev, cccInfo: e.target.value }))
                  }
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Colors: </label>
              </td>
              <td className="w-full">
                <Input
                  className="w-full"
                  value={product.colors}
                  onChange={(e) =>
                    setProduct((prev) => ({
                      ...prev,
                      colors: e.target.value,
                    }))
                  }
                  placeholder=""
                />
              </td>
            </tr>

            {Object.keys(barcodes).map((key) => (
              <tr key={key}>
                <td>
                  <label>{barcodes[key]}: </label>
                </td>
                <td className="w-full">
                  <Input
                    className="w-full"
                    value={product[key]}
                    onChange={(e) =>
                      setProduct((prev) => ({
                        ...prev,
                        [key]: e.target.value,
                      }))
                    }
                    placeholder=""
                  />
                </td>
              </tr>
            ))}

            <tr>
              <td>
                <label>Inner Box Size: </label>
              </td>
              <td>
                <CubeSizeInput
                  x={product.innerBoxX}
                  y={product.innerBoxY}
                  z={product.innerBoxZ}
                  onChange={({ x, y, z }) =>
                    setProduct((prev) => ({
                      ...prev,
                      innerBoxX: x,
                      innerBoxY: y,
                      innerBoxZ: z,
                    }))
                  }
                />
              </td>
            </tr>

            <tr>
              <td>
                <label>Display Box Size: </label>
              </td>
              <td>
                <CubeSizeInput
                  x={product.displayBoxX}
                  y={product.displayBoxY}
                  z={product.displayBoxZ}
                  unit="mm"
                  onChange={({ x, y, z }) =>
                    setProduct((prev) => ({
                      ...prev,
                      displayBoxX: x,
                      displayBoxY: y,
                      displayBoxZ: z,
                    }))
                  }
                />
              </td>
            </tr>

            <tr>
              <td>
                <label>Inner Carton Size: </label>
              </td>
              <td>
                <CubeSizeInput
                  x={product.innerCartonX}
                  y={product.innerCartonY}
                  z={product.innerCartonZ}
                  unit="cm"
                  onChange={({ x, y, z }) =>
                    setProduct((prev) => ({
                      ...prev,
                      innerCartonX: x,
                      innerCartonY: y,
                      innerCartonZ: z,
                    }))
                  }
                />
              </td>
            </tr>

            <tr>
              <td>
                <label>Outer Carton Size: </label>
              </td>
              <td>
                <div className="flex space-x-2 items-center">
                  <CubeSizeInput
                    x={product.outerCartonX}
                    y={product.outerCartonY}
                    z={product.outerCartonZ}
                    unit="cm"
                    onChange={({ x, y, z }) =>
                      setProduct((prev) => ({
                        ...prev,
                        outerCartonX: x,
                        outerCartonY: y,
                        outerCartonZ: z,
                      }))
                    }
                  />
                  <div>
                    <div>
                      <label>CBM: </label>{" "}
                      {outerCartonCbm(
                        product.outerCartonX,
                        product.outerCartonY,
                        product.outerCartonZ,
                      ).toFixed(4)}{" "}
                      m³
                    </div>
                    <div className="text-xs text-gray-600">
                      ((x + 0.5) * (y + 0.5) * (z + 0.5)) / (100 * 100 * 100)
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <label>Qty / Display Box: </label>
              </td>
              <td>
                <Input
                  className="text-center"
                  value={product.quantityPerDisplayBox}
                  onChange={(e) =>
                    setProduct((prev) => ({
                      ...prev,
                      quantityPerDisplayBox: parseFloatValue(e.target.value),
                    }))
                  }
                />
              </td>
            </tr>

            <tr>
              <td>
                <label>Qty / Carton: </label>
              </td>
              <td>
                <Input
                  className="text-center"
                  value={product.quantityPerCarton}
                  onChange={(e) =>
                    setProduct((prev) => ({
                      ...prev,
                      quantityPerCarton: parseFloatValue(e.target.value),
                    }))
                  }
                />
              </td>
            </tr>

            <tr>
              <td>
                <label>CTN Net Weight(kg): </label>
              </td>
              <td>
                <Input
                  className="text-center"
                  value={product.ctnNetWeight}
                  onChange={(e) =>
                    setProduct((prev) => ({
                      ...prev,
                      ctnNetWeight: parseFloatValue(e.target.value),
                    }))
                  }
                />
              </td>
            </tr>

            <tr>
              <td>
                <label>CTN Gross Weight(kg): </label>
              </td>
              <td>
                <Input
                  className="text-center"
                  value={product.ctnGrossWeight}
                  onChange={(e) =>
                    setProduct((prev) => ({
                      ...prev,
                      ctnGrossWeight: parseFloatValue(e.target.value),
                    }))
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PackingShipmentView;
